<div data-testid="project-user-management" *transloco="let t">
  <p-tabs appTabsUnsavedReveal [(value)]="activeTabIndex" scrollable>
    <p-tablist data-testid="project-user-management-tablist" [ngClass]="'mb-5'">
      @for (tabItem of tabItems; track $index) {
        <p-tab [value]="tabItem" [attr.data-testid]="'project-user-management-tab-' + $index"
          >{{ t('userManagement.tab.' + tabItem) }}
        </p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="tabItems[0]" [attr.data-testid]="'user-list-tab-panel'">
        <app-project-user-list />
      </p-tabpanel>
      <p-tabpanel [value]="tabItems[1]" [attr.data-testid]="'user-invitation-template-tab-panel'">
        <app-user-invitation-template-list />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
